export function arrayIncludes<T extends Array<any> | ReadonlyArray<any>>(array: T, value: any): value is T[number] {
  return array.includes(value)
}
